module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('report-settings')], 1), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [(_vm.$route.name === 'reports') ? _c('span', [_vm._v("\n                        Reports\n                    ")]) : _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'reports'
      }
    }
  }, [_vm._v("\n                            Reports\n                        ")]), _vm._v("\n                        →\n                        "), (_vm.$route.name === 'sales-by-pack') ? _c('span', [_vm._v("\n                            Sales by Pack\n                        ")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f49b1ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Reports.vue
// module id = 552
// module chunks = 0